import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ManageProjectsTable from './ManageProjectsTable';

const DataTable = ({ data, activeTab, handleClick, description }) => {
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  //   const [activeTab, setActiveTab] = useState('soc');
  const { socDesc, swrcDesc } = description;

  const allMonths = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  const [months, setMonths] = useState(allMonths);

  // Function to extract years from the data object
  const getYears = data => {
    const firstKey = Object.keys(data)[0];
    if (firstKey) {
      const firstObject = data[firstKey];
      let keys = Object.keys(firstObject[0]);
      return Object.keys(firstObject[0]).filter(key => !isNaN(key));
    }
    return [];
  };

  const years = getYears(data);
  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth(); // 0-based index for months
  //   const yearss = Object.keys(firstObject).filter(key => !isNaN(key));

  useEffect(() => {
    // Initialize the selected year and month if not already set
    if (!selectedYear) setSelectedYear(years[0] || '');
    if (!selectedMonth) setSelectedMonth(allMonths[0] || '');
  }, [years, selectedYear, selectedMonth]);

  useEffect(() => {
    // Filter months based on the selected year
    const monthOptions =
      selectedYear === currentYear.toString()
        ? allMonths.slice(0, currentMonthIndex)
        : allMonths;

    setMonths(monthOptions);

    // Reset selected month if it is not available for the new year
    if (!monthOptions.includes(selectedMonth)) {
      setSelectedMonth(monthOptions[0]);
    }
  }, [
    selectedYear,
    currentMonthIndex,
    selectedMonth,
    setSelectedMonth,
    currentYear
  ]);

  return (
    <div>
      {activeTab === 'soc' ? (
        data.Soc && (
          <ManageProjectsTable
            key={'SOC'}
            id={'SOC'}
            data={data.Soc}
            handleClick={handleClick}
            type={'Soil Organic Carbon'}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
            allMonths={months}
            hyperlink={true}
            description={socDesc}
          />
        )
      ) : activeTab === 'water' ? (
        data?.Soil_Water_Retention_Capacity ? (
          <ManageProjectsTable
            id={'SOIL_WATER_RETENTION_CAPACITY'}
            key={'SOIL_WATER_RETENTION_CAPACITY'}
            data={data.Soil_Water_Retention_Capacity}
            handleClick={handleClick}
            type={'Soil Water Retention Capacity'}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
            allMonths={months}
            hyperlink={false}
            description={swrcDesc}
          />
        ) : (
          <h5>NO Data</h5>
        )
      ) : null}
    </div>
  );
};
export default DataTable;

DataTable.propTypes = {
  data: PropTypes.shape({
    Soc: PropTypes.object.isRequired,
    Soil_Water_Retention_Capacity: PropTypes.object.isRequired
  }).isRequired,
  activeTab: PropTypes.string,
  handleClick: PropTypes.func,
  description: PropTypes.object
};
